@if(!connectorExist())
{
    <div class="alert warning">
        No connector configured.
    </div>
}
<ng-template connectorHost></ng-template>